/**
 * WHAT: Session timeout warning modal with countdown timer.
 * WHY: DAMA handles sensitive access governance data, so sessions must time out
 *      after inactivity -- this modal gives users a chance to extend their session
 *      before automatic logout protects against unattended workstations.
 */

import React from 'react';

/**
 * WHAT: Centered modal displaying a countdown timer with stay/logout options.
 * WHY: Provides a user-friendly warning before forced logout so attesters
 *      working on reviews do not lose their progress unexpectedly.
 */
const InactivityWarningModal = ({
  isOpen,
  secondsRemaining,
  onStayLoggedIn,
  onLogoutNow
}) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1050 }}
      />

      {/* Modal */}
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        style={{ zIndex: 1055 }}
        role="dialog"
        aria-labelledby="inactivityWarningTitle"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content border-warning">
            <div className="modal-header bg-warning text-dark">
              <h5 className="modal-title" id="inactivityWarningTitle">
                <i className="fas fa-exclamation-triangle me-2"></i>
                Session Timeout Warning
              </h5>
            </div>
            <div className="modal-body text-center py-4">
              <div className="mb-3">
                <i className="fas fa-clock fa-3x text-warning"></i>
              </div>
              <p className="lead mb-2">Your session is about to expire due to inactivity.</p>
              <p className="text-muted mb-3">You will be automatically logged out in:</p>
              <div
                className="display-4 fw-bold text-danger mb-3"
                role="timer"
                aria-live="polite"
              >
                {secondsRemaining} {secondsRemaining === 1 ? 'second' : 'seconds'}
              </div>
              <p className="text-muted small">
                Click "Stay Logged In" to continue your session.
              </p>
            </div>
            <div className="modal-footer justify-content-center border-0 pt-0">
              <button
                type="button"
                className="btn btn-outline-secondary px-4"
                onClick={onLogoutNow}
              >
                <i className="fas fa-sign-out-alt me-2"></i>
                Logout Now
              </button>
              <button
                type="button"
                className="btn btn-primary px-4"
                onClick={onStayLoggedIn}
                autoFocus
              >
                <i className="fas fa-check me-2"></i>
                Stay Logged In
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InactivityWarningModal;
